import { TableConfigV2 } from 'hooks/useMuiTableBuilderV2';
import { HeaderCell } from 'components/Cells/HeaderCell';
import { columns, COLUMNS } from './columns';
import ServiceMetricsExpandToggleCell from './DataCells/ServiceMetricsExpandToggleCell';
import ServiceMetricsTeamNameCell from './DataCells/ServiceMetricsTeamNameCell';
import ServiceMetricsTextCell from './DataCells/ServiceMetricsTextCell';
import ServiceMetricsHealthCell from './DataCells/ServiceMetricsHealthCell';
import ServiceMetricsSummaryCell from './DataCells/ServiceMetricsSummaryCell';
import ServiceMetricsDetailsRowCell from './DataCells/ServiceMetricsDetailsRowCell';
import { EmptyCell } from 'components/Cells/EmptyCell';

export const ROW_TYPES = {
  HEADER: 'HEADER',
  DATA: 'DATA',
  DETAILS: 'DETAILS',
} as const;

export const getTableConfig = (): TableConfigV2 => {
  return {
    hasStickyHeader: true,
    tableHeaderTitle: 'Sync Ratio Per Integration',
    rowTypes: ROW_TYPES,
    hideToolbar: false,
    columns,
    columnsMinWidth: {
      [COLUMNS.EXPAND]: 60,
      [COLUMNS.TEAM_NAME]: 200,
      [COLUMNS.TEAM_ID]: 100,
      [COLUMNS.INTEGRATION_ID]: 140,
      [COLUMNS.HEALTH]: 100,
      [COLUMNS.SUMMARY]: 200,
    },
    cellsByRowTypesAndColumns: {
      [ROW_TYPES.DATA]: {
        [COLUMNS.EXPAND]: ServiceMetricsExpandToggleCell,
        [COLUMNS.TEAM_NAME]: ServiceMetricsTeamNameCell,
        [COLUMNS.TEAM_ID]: ServiceMetricsTextCell,
        [COLUMNS.INTEGRATION_ID]: ServiceMetricsTextCell,
        [COLUMNS.HEALTH]: ServiceMetricsHealthCell,
        [COLUMNS.SUMMARY]: ServiceMetricsSummaryCell,
      },
      [ROW_TYPES.HEADER]: {
        [COLUMNS.EXPAND]: HeaderCell,
        [COLUMNS.TEAM_NAME]: HeaderCell,
        [COLUMNS.TEAM_ID]: HeaderCell,
        [COLUMNS.INTEGRATION_ID]: HeaderCell,
        [COLUMNS.HEALTH]: HeaderCell,
        [COLUMNS.SUMMARY]: HeaderCell,
      },
      [ROW_TYPES.DETAILS]: {
        // Only the first column will be rendered for DETAILS rows (full-width)
        [COLUMNS.EXPAND]: ServiceMetricsDetailsRowCell,
        [COLUMNS.TEAM_NAME]: EmptyCell,
        [COLUMNS.TEAM_ID]: EmptyCell,
        [COLUMNS.INTEGRATION_ID]: EmptyCell,
        [COLUMNS.HEALTH]: EmptyCell,
        [COLUMNS.SUMMARY]: EmptyCell,
      },
    },
  };
};

export default getTableConfig;
